import RowGroup from './RowGroup'

export const TBodyCustom = ({ ids, schema, typePrefix, isDynamicReport }) => {
  return (
    <tbody>
      {ids.map((rowId, groupRowIndex) => {
        return (
          <RowGroup
            key={rowId}
            rowId={rowId}
            schema={schema}
            typePrefix={typePrefix}
            groupRowIndex={groupRowIndex}
            isDynamicReport={isDynamicReport}
          />
        )
      })}
    </tbody>
  )
}
